<template>
  <div>
    <div class="box mb20">
      <el-page-header
        @back="$router.go(-1)"
      ></el-page-header>
    </div>
    <el-card class="mb15" shadow="hover">
      <el-row>
        <el-input
          :placeholder="$t('search')"
          clearable
          v-model="filter.search"
          @keyup.enter.native="get_list"
        ></el-input>
      </el-row>
      <el-row class="mt20" type="flex" align="middle">
        <el-button @click="get_list" type="primary" class="search">{{
          $t("search_zh")
        }}</el-button>
        <el-button @click="reset" type="info">{{
          $t("btnTip.reset")
        }}</el-button>
      </el-row>
    </el-card>
    <el-card shadow="hover">
      <div class="flexBC mb20">
       <div></div>
        <div>
          <el-button type="primary" @click="outExe">{{ $t("outExe") }}</el-button>
          <el-button
              type="primary"
              @click="outExeAll('readAttendance')"
              >전체출력</el-button>
        </div>
      </div>
      <my-table
        :columns="columns"
        :data="list_data.list"
        :showIndex="false"
        :showSelection="false"
        :cellStyle="{ padding: '6px 0' }"
        :headerCellStyle="{
          background: 'rgba(51, 55, 68, 1)',
          color: '#fff',
        }"
        @emitSelection="allSelect"
        @sortChange="sort_change"
      >
        <template v-slot:content="slotProps">
          <div class="mutiple" v-html="slotProps.callback.row.content"></div>
        </template>
        <template v-slot:operation="slotProps">
            <el-button
              @click="handleClick('toCommentList',slotProps.callback.row)"
              type="warning"
              size="mini"
            >{{$t('attendanceList.toCommentList')}}</el-button>
            <el-button
              @click="del(slotProps.callback.row.id)"
              type="danger"
              size="mini"
            >{{$t('btnTip.delete')}}</el-button>
        </template>
      </my-table>
      <page
        :total="list_data.total"
        :page_size.sync="pageSize"
        :page.sync="page"
      />
    </el-card>
  </div>
</template>
<script>
import { mixin_list } from "@/mixins";
import page from "@/components/page";
import myTable from "@/components/table";
import { attendanceList, deleteAttendanceComment } from "@/api/api";
export default {
  name: "attendanceList",
  mixins: [mixin_list(attendanceList)],
  components: {
    myTable,
    page,
  },
  data() {
    return {
      filter: {
        search: "",
        task:this.$route.params.taskId
      },
      columns: [
        {
          label: "ID",
          sortable: true,
          prop: "id",
          width: 80,
        },
        {
          label: this.$t("attendanceList.username"),
          sortable: true,
          prop: "username",
        },
        {
          label: this.$t("attendanceList.real_name"),
          sortable: true,
          prop: "real_name",
        },
        {
          label: this.$t("attendanceList.task_title"),
          sortable: true,
          prop: "task_title",
        },
        {
          label: this.$t("attendanceList.title"),
          sortable: true,
          prop: "title",
        },
        {
          label: this.$t("attendanceList.content"),
          sortable: true,
          prop: "content",
          slot:"content"
        },
        {
          label: this.$t("attendanceList.attach"),
          sortable: true,
          prop: "attach",
        },
        {
          label: this.$t("operation"),
          prop: "",
          width: 300,
          slot: "operation",
        },
      ]
    }
  },
  methods: {
    async handleClick(type, data) {
      switch (type) {
        case "toCommentList":
             this.$router.push(`/readManagement/readList/${this.$route.params.readId}/readTaskList/${this.$route.params.taskId}/attendanceList/comment?id=${data.id}`)
          break;
      }
    },
    async del(id) {
      this.$confirm(this.$t('readTaskList').sureDeleteTask, this.$t('tips'), {
        confirmButtonText: this.$t('btnTips').submit,
        cancelButtonText: this.$t('btnTips').cancel,
        type: 'warning'
      }).then(async () => {
        let res = await deleteAttendanceComment({id})
        this.get_list()
      }).catch({
      })
    },
  },
};
</script>
<style lang="scss" scoped>

</style>